import { ContextualSaveBar, Layout, Page } from "@shopify/polaris";
import { useRef, useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useHistory, useParams } from "react-router";

import { getOneUser, updateOneUser } from "api";
import { useSnackbar } from "providers";
import { SharedForm } from "../SharedForm";

export function UserDetail(props) {
  const skipToContentRef = useRef(null);
  const { userId } = useParams();

  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getOneUserOnsuccess = (response) => {
    const payload = {
      name: response.name,
      email: response.email,
      tel: response.tel,
      avatar: undefined,
      status: response.status,
    };
    setInitialValues(payload);
  };

  const { toggleSnack } = useSnackbar();

  useQuery(["users", userId], () => getOneUser(userId), {
    onSuccess: getOneUserOnsuccess,
  });

  const patchMutation = useMutation(
    (payload) => updateOneUser(payload, userId),
    {
      onSuccess: (response) => {
        toggleSnack({
          key: "userUpdateSuccess",
          message: "Muhasebe kaydı başarıyla güncellenmiştir",
          active: true,
        });
      },
      onError: (error) => {
        toggleSnack({
          key: "userUpdateError",
          error: true,
          message: error?.response?.data?.message,
          active: true,
        });
      },
    }
  );

  return (
    <Page
      title="Kullanıcı Detay"
      narrowWidth={true}
      breadcrumbs={[{ content: "Kullanıcılar", url: "/users" }]}
    >
      <Layout>
        <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
        {initialValues && (
          <SharedForm
            initialValues={initialValues}
            isDetail={true}
            onSubmit={(values) => patchMutation.mutate(values)}
            savebarRender={(values) => (
              <Savebar {...values} isLoading={patchMutation.isLoading} />
            )}
          />
        )}
      </Layout>
    </Page>
  );
}

function Savebar({ handleSubmit, isValid, isLoading }) {
  const history = useHistory();
  return (
    <ContextualSaveBar
      saveAction={{
        onAction: handleSubmit,
        loading: isLoading,
        disabled: !isValid,
        content: "Güncelle",
      }}
      message="Kullanıcı Detay"
      discardAction={{
        onAction: () => history.push("/users"),
        content: "Geri",
      }}
    />
  );
}
